export enum Variants {
    Filled = 'filled',
    Outline = 'outline',
}

export enum Colors {
    Primary = 'primary',
    Secondary = 'secondary',
    Warning = 'warning',
    Danger = 'danger',
    Success = 'success',
    Info = 'info',
    Dark = 'dark',
}

export type Color = `${Colors}`;

export type Variant = `${Variants}`;

export type ColorProps = {
    color: Color;
    variant?: Variant;
};

export type ColorsDictionary = {
    [key in Colors]: string;
};

export type VariantsDictionary = {
    [key in Variants]: string;
};
